// Breakpoints from Ant Design
export const breakpoints = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xlMedium: 1400,
  xxl: 1600,
};

// Media query strings for CSS
export const mediaQueries = {
  xs: `(max-width: ${breakpoints.xs - 1}px)`,
  sm: `(min-width: ${breakpoints.sm}px)`,
  md: `(min-width: ${breakpoints.md}px)`,
  lg: `(min-width: ${breakpoints.lg}px)`,
  xl: `(min-width: ${breakpoints.xl}px)`,
  xxl: `(min-width: ${breakpoints.xxl}px)`,
};

// Device type queries
export const deviceQueries = {
  mobile: `(max-width: ${breakpoints.lg - 1}px)`,
  tablet: `(min-width: ${breakpoints.sm}px) and (max-width: ${breakpoints.lg - 1
    }px)`,
  desktop: `(min-width: ${breakpoints.lg}px)`,
  smallDevice: `(max-width: ${breakpoints.lg - 1}px)`,
  mdDevices: `(max-width: ${breakpoints.md}px)`,
  lgDevices: `(max-width: ${breakpoints.lg}px)`,
  xlDevices: `(max-width: ${breakpoints.xl}px)`,
  xlMediumDevices: `(max-width: ${breakpoints.xlMedium}px)`,
};

// Helper function to get current device type
export const isSmallDevice = (): boolean => window?.innerWidth < breakpoints.lg;

export const colors = {
  primary: "#4119f3",
  lightPrimary: "#6b52f5",
  success: "#4caf50",
  warning: "#ff9800",
  error: "#f44336",
  gray: "#fafafa",
  white: "#fff",
  black: "#000",
  darkGray: "#999",
  black3: "#333333",
  titles: 'rgb(8 28 69)',
  purple: '#6b52f5',
};

export const themeConfig = {
  token: {
    colorPrimary: colors.primary,
    borderRadius: 0,
    boxShadowTertiary:
      "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)",
    colorLink: colors.primary,
    colorLinkHover: colors.lightPrimary,
    colorLinkActive: colors.lightPrimary,
    fontFamily: '"Open Sans", sans-serif',
  },
  components: {
    Layout: {
      headerBg: colors.white,
      headerHeight: 50,
      bodyBg: colors.gray,
      siderBg: colors.gray,
    },
    Menu: {
      itemColor: colors.black,
      activeBarBorderWidth: 0,
      itemBg: "transparent",
      itemHoverBg: "rgba(0, 0, 0, 0.04)",
      itemSelectedBg: "rgba(0, 0, 0, 0.05)",
      itemHoverColor: colors.black,
      itemSelectedColor: colors.black3,
      subMenuItemSelectedColor: colors.black3,
    },
    Button: {
      defaultBg: "transparent",
      defaultHoverBg: "transparent",
      defaultBorderColor: colors.darkGray,
      defaultColor: colors.black,
      defaultHoverColor: colors.black,
      defaultGhostBorderColor: colors.darkGray,
      defaultGhostColor: colors.black,
      defaultHoverBorderColor: colors.black,
      contentFontSizeSM: 12,
    },
    Card: {
      headerHeight: 46,
      headerHeightSM: 32,
      headerBg: `linear-gradient(to bottom, #f9f9f9, #fff)`,
    },
    Modal: {
      titleFontSize: 22,
    },
    Table: {
      headerBg: "#f9fafb",
      cellPaddingBlock: 12,
      cellPaddingInline: 12,
    },
    Tabs: {
      itemActiveColor: colors.black,
      itemColor: colors.titles,
      itemHoverColor: colors.black,
      itemSelectedColor: colors.black,
      inkBarColor: colors.black,
    },
    Descriptions: {
      labelColor: colors.titles
    },
    Input: {
      addonBg: 'transparent',
    }
  },
};
